'use client'

import { useEffect, useRef } from 'react'
import { useUser } from '@stackframe/stack'

const CLAIM_LOCK_KEY = 'rw_guest_rating_claim'

export function ClaimGuestRating() {
  const user = useUser()
  const inFlight = useRef(false)

  useEffect(() => {
    if (!user || inFlight.current) return
    if (typeof window === 'undefined') return

    // Survives Strict Mode remounts and layout re-renders in the same tab.
    if (sessionStorage.getItem(CLAIM_LOCK_KEY) === user.id) return

    inFlight.current = true
    sessionStorage.setItem(CLAIM_LOCK_KEY, user.id)

    fetch('/api/ratings/claim', { method: 'POST' })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}))
        // Keep the lock after a successful claim (or no pending rating).
        // Only unlock on hard failure so a retry can happen.
        if (!res.ok && res.status >= 500) {
          sessionStorage.removeItem(CLAIM_LOCK_KEY)
          inFlight.current = false
        }
        return data
      })
      .catch(() => {
        sessionStorage.removeItem(CLAIM_LOCK_KEY)
        inFlight.current = false
      })
  }, [user])

  return null
}
